module.exports = __webpack_public_path__ + "img/sair_icon.2f29143a.svg";